<template lang="pug">
  div.live-by
    h3 生存之道
    ul
      li
        h4 开拓创新
        p 与众不同 – “不同“可以激发我们的文化，故事和产品，我们为不同观点碰撞而迸发出的火花鼓掌。
      li
        h4 执行能力
        p 不断进步 – 我们分析不同方式的价值而提升未来的能力。
      li
        h4 企业家精神
        p 敢于冒险 – 在可控风险之内不断提升我们的人员及产品。
      li
        h4 个人担当
        p 使命使然 - 我们相信有责任感的员工更值得被信任也会在自由的环境中熠熠生辉。
      li
        h4 感恩的心
        p 感恩之心 - 谦逊待人；及时肯定他人结果，也不标榜自己的成就

</template>
<script>
export default {
  name: 'LiveBy'
}
</script>
<style lang="scss" scoped>
.live-by {
  padding-top: 3.75rem;
  padding: 0 15px;
  overflow: hidden;
  ul {
    padding: 0 15px;
  }
  h3 {
    color:#1a1a1a;
    text-align: center;
    font-size: 2.29rem;
    text-align: center;
  }
  h4 {
    font-size: 1.43rem;
    color:#1a1a1a;
    margin: 0.5rem 0;
    text-transform: uppercase;
    font-weight: normal;
    font-family: akzidenz-grotesk-condensed;
  }
}

@media only screen and (min-width: 768px) {
  .live-by {
    max-width: 80rem;
    margin: 0 auto;
    ul {
      display: flex;
      flex-flow: row nowrap;
      li {
        width: 20%;
        // flex: 1;
        padding: 0 15px;
      }
    }
  }
}
</style>
